import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TagModule } from 'primeng/tag';

@Component({
    selector: 'app-manual-source-badge',
    standalone: true,
    imports: [CommonModule, TagModule],
    template: `
        <div class="manual-source">
            <p-tag [value]="sourceType || 'SYSTEM'" [severity]="sourceType === 'MANUAL' ? 'warn' : 'info'"></p-tag>
            <span *ngIf="sourceReference">{{ sourceReference }}</span>
            <span *ngIf="manualReasonCode" class="reason">{{ manualReasonCode }}</span>
        </div>
    `,
    styles: [`
        .manual-source {
            display: inline-flex;
            align-items: center;
            flex-wrap: wrap;
            gap: .4rem;
        }

        .manual-source span {
            color: #475569;
            font-size: .85rem;
        }

        .manual-source .reason {
            color: #92400e;
            background: #fffbeb;
            border: 1px solid #fde68a;
            border-radius: 999px;
            padding: .15rem .5rem;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualSourceBadgeComponent {
    @Input() sourceType?: string;
    @Input() sourceReference?: string;
    @Input() manualReasonCode?: string;
}
